<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'organization'"></app-header-bar>
  </div>
  <div class="content mt-2 mb-3">
    <form [formGroup]="form">
      <div class="col-md-3">
        <div class="row form-group">
          <label>{{ 'organizations.name' | translate }}</label>
          <app-input-with-error
            [control]="this.form.controls['name']"
          ></app-input-with-error>
        </div>
        <div class="row form-group">
          <label>{{ 'organizations.owner' | translate }}</label>
          <div>
            <p-select
              [options]="users"
              dataKey="id"
              formControlName="owner"
              [placeholder]="'organizations.chooseOwner' | translate"
            >
              <ng-template let-item pTemplate="selectedItem">
                <div>{{ item.given_name + ' ' + item.family_name }}</div>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <div>{{ item.given_name + ' ' + item.family_name }}</div>
              </ng-template>
            </p-select>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button
            [disabled]="!form.valid || !changed()"
            type="button"
            class="btn btn-secondary"
            (click)="save()"
            [ladda]="loading"
          >
            {{ 'save' | translate }}
          </button>
        </div>
      </div>
    </form>
    <app-error [error]="error"></app-error>
  </div>
</div>
